/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { LTIAssignmentLaunchData } from './LTIAssignmentLaunchData';
import { LTIDeepLinkResult } from './LTIDeepLinkResult';
import { LTITemplatePreviewLaunchData } from './LTITemplatePreviewLaunchData';
import { LTIVersion } from './LTIVersion';
const LTILaunchResultParser = /* #__PURE__ */ parsers.object([
    [
        'data',
        /* #__PURE__ */ parsers.taggedUnion('type', [
            ['normal_result', LTIAssignmentLaunchData],
            ['template_preview_result', LTITemplatePreviewLaunchData],
            ['deep_link', LTIDeepLinkResult],
        ]),
    ],
    ['version', LTIVersion],
]);
export class LTILaunchResult extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return LTILaunchResultParser.decode(input).map(res => new LTILaunchResult(res));
    }
    static unsafeDecode(input) {
        return LTILaunchResult.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return LTILaunchResultParser.encode(data);
    }
    static schema() {
        return LTILaunchResultParser.schema();
    }
}
